import React from "react";

/**
 * "SUGGESTED RESPONSES" section rendered INSIDE the chat input card during onboarding
 * (design "Introduction" mock). Data source is the OnboardingHubV1 payload's
 * SuggestedResponses field — not /Suggestions/Retriever. On the completion step the
 * chips are questions to ask Mila, so the caller overrides the title accordingly.
 */
const OnboardingSuggestedResponses = ({ suggestions, onSelect, disabled, title = "Suggested responses" }) => {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="border-t border-[#F0E5FB] px-4 pt-3 pb-3">
      <span className="block text-[11px] font-semibold tracking-wider text-dimgray-200 uppercase mb-2">
        {title}
      </span>
      <div className="flex flex-col items-start gap-1">
        {suggestions.map((s, i) => (
          <button
            key={i}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(s)}
            className="flex items-center gap-2 px-2 py-1.5 rounded-lg text-dark-blue-100 text-[13px] font-notosans hover:bg-[#F3F1FF] transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-left w-full"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="shrink-0 text-dimgray-200"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
            {s}
          </button>
        ))}
      </div>
    </div>
  );
};

export default OnboardingSuggestedResponses;
